export default {"src":"/login-app/[GIT_HASH]/_next/static/media/graduation_cap.ca9d9592.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};